module.exports = __webpack_public_path__ + "static/flags/HO-9adb8dd09d08c7cda4145bed0f2086cf.gif";